// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"76a48070","244":"decc6166","353":"e3c369a7"}[chunkId] + ".chunk.css";
};